import React, { useRef } from 'react';
import { useHistory } from 'react-router-dom';
import BasePage from '../../../core/page/BasePage';
import BaseFilter from '../../../core/page/components/baseFilter/BaseFilter';
import Pages from '../../../config/Pages';
import { inputsSolicitacoes } from './PageInputs';
import RotuloSeplag from '../../../components/rotuloSeplag/RotuloSeplag';
import AutoCompleteDropDown from '../../../core/components/inputs/AutoCompleteDropDown';
import { InputText } from 'primereact/inputtext';
import { useOrgao } from '../Utils';
import { useInputs } from '../../../core/utils/Hooks';
import ConfirmDialog from '../../../core/components/ConfirmDialog';
import solicitacaoAtivacaoIndicadorService from '../../../service/SolicitacaoAtivacaoIndicadorService';
import orgaoIntegracaoService from '../../../service/integracao/OrgaoIntegracaoService';
import builder from '@rsql/builder';
import pessoaIntegracaoService from '../../../service/integracao/PessoaIntegracaoService';
import InputDropDown from '../../../core/components/inputs/inputDropDown/InputDropDown';
import ButtonSeplag from '../../../components/buttonSeplag/ButtonSeplag';
import tipoSolicitacaoAtivacaoService from '../../../service/TipoSolicitacaoAtivacaoService';
import situacaoSolicitacaoAtivacaoService from '../../../service/SituacaoSolicitacaoAtivacaoService';

function IndicadorSolicitacoes() {
    const orgaoUsuarioLogado = useOrgao();
    const filterInputs = useInputs(inputsSolicitacoes);
    const confirmRef = useRef(null);
    const formRef = useRef(null);
    const history = useHistory();

    const Rotulo = ({ children, ...rest }) => (
        <RotuloSeplag useInput={filterInputs} {...rest}>
            {children}
        </RotuloSeplag>
    );

    const Inputs = ({ formik }) => {
        return (
            <>
                <Rotulo cols="12 6">
                    <AutoCompleteDropDown
                        name="orgao"
                        formik={formik}
                        field="descOrgao"
                        disabled={orgaoUsuarioLogado?.siglOrgao !== 'SEPLAG'}
                        service={orgaoIntegracaoService.autoComplete.bind(orgaoIntegracaoService)}
                    />
                </Rotulo>
                <Rotulo cols="12 3">
                    <InputText
                        name="contaAcessoCadastro"
                        value={formik.values.contaAcessoCadastro}
                        onChange={formik.handleChange}
                    />
                </Rotulo>
                <Rotulo cols="12 3">
                    <AutoCompleteDropDown
                        name="responsavelAnalise"
                        formik={formik}
                        field={'nomePessoa'}
                        service={pessoaIntegracaoService.autoComplete.bind(pessoaIntegracaoService)}
                    />
                </Rotulo>
                <Rotulo cols="12 3">
                    <InputDropDown
                        name="tipoSolicitacaoAtivacao"
                        formik={formik}
                        optionLabel="descTipoSolicitacaoAtivacao"
                        callbackSetList={tipoSolicitacaoAtivacaoService.list.bind(
                            tipoSolicitacaoAtivacaoService
                        )}
                    />
                </Rotulo>
                <Rotulo cols="12 3">
                    <InputDropDown
                        name="situacao"
                        formik={formik}
                        valueIsCompleteObject
                        optionValue="codgSituacaoSolicitacaoAtivacao"
                        optionLabel="descSituacaoSolicitacaoAtivacao"
                        callbackSetList={situacaoSolicitacaoAtivacaoService.list.bind(
                            situacaoSolicitacaoAtivacaoService
                        )}
                    />
                </Rotulo>
                <Rotulo cols="12 3">
                    <InputText
                        name="codigoIndicador"
                        value={formik.values.codigoIndicador}
                        onChange={formik.handleChange}
                        keyfilter="int"
                    />
                </Rotulo>
                <Rotulo cols="12 3">
                    <InputText
                        name="nomeIndicador"
                        value={formik.values.nomeIndicador}
                        onChange={formik.handleChange}
                    />
                </Rotulo>
            </>
        );
    };

    return (
        <>
            <ConfirmDialog ref={confirmRef} />
            <BasePage
                service={solicitacaoAtivacaoIndicadorService}
                page={{
                    pageUrls: Pages.sei.indicadorSolicitacoes.url,
                    legenda: Pages.sei.indicadorSolicitacoes.legenda,
                    pageName: Pages.sei.indicadorSolicitacoes.title,
                }}
                initialValues={inputsSolicitacoes.filter((input) => input?.table?.use ?? false)}
                addAfterActions={({ id }) => (
                    <ButtonSeplag
                        tipo="warning"
                        type="button"
                        tooltip="Analisar Solicitação"
                        tooltipOptions={{ position: 'top' }}
                        icon="pi pi-file-edit"
                        onClick={() =>
                            history.push(
                                Pages.sei.indicadorSolicitacoes.url.edit.replace(':id', id)
                            )
                        }
                        style={{ marginLeft: '6px' }}
                    />
                )}
                enableAlterar={false}
                enableAdicionar={false}
                enableEditar={false}
                enableExcluir={false}
            >
                <BaseFilter
                    ref={formRef}
                    initialValues={inputsSolicitacoes.filter(
                        (input) => input?.filter?.use ?? false
                    )}
                    customFilter={{
                        responsavelAnalise: ({ nameUse, original }) =>
                            builder.comparison(nameUse, '==', original?.idenPessoa),
                        orgao: ({ nameUse, original }) =>
                            builder.comparison(nameUse, '==', original?.idenOrgao),
                        situacao: ({ nameUse, original }) =>
                            builder.comparison(
                                nameUse,
                                '==',
                                original?.codgSituacaoSolicitacaoAtivacao
                            ),
                    }}
                    prepareInitialValues={async (dados) => ({
                        ...dados,
                        orgao: orgaoUsuarioLogado,
                        situacao: { codgSituacaoSolicitacaoAtivacao: 'PENDENTE' },
                    })}
                    noEmptyInputsOnClear={orgaoUsuarioLogado?.siglOrgao === 'SEPLAG'}
                >
                    <Inputs />
                </BaseFilter>
            </BasePage>
        </>
    );
}

export default IndicadorSolicitacoes;
